import script from "./BaseThemeView.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseThemeView.vue?vue&type=script&setup=true&lang=js"

import "./BaseThemeView.vue?vue&type=style&index=0&id=61d897ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61d897ee"]])

export default __exports__